export default {
  notActivated: 'Inactive',
} as const;
